import React, { useState, useMemo } from 'react';
import KeymastersPotCheckbox from '../../Checkbox';
import YourRewardsTabAdvancedMode from './AdvancedMode';
import YourRewardsTabRegularMode from './RegularMode';
import keymastersPotAdvancedModeAtom from 'src/state/keymastersPotAdvancedModeAtom';
import { useRecoilState } from 'recoil';

// key.png

export default function YourRewardsTab({ keys, onClickClaim, paused }) {

	const [isAdvancedMode, setIsAdvancedMode] = useRecoilState( keymastersPotAdvancedModeAtom );

	const claimableTotalAmount = useMemo( ()=>{
		return keys.reduce( ( a, v )=>a + ( v.claimable ), 0 );
	}, [keys]);

	const onClaimAllClick = () => !paused && onClickClaim( keys.map( key => key.id ) );

	return <div className='mt-12'>
		<div className='relative flex justify-center items-start'>
			<KeymastersPotCheckbox
				variation="keymaster"
				isSelected={isAdvancedMode}
				onClick={() => setIsAdvancedMode( ( prev ) => !prev )} />
			<span className='mt-[5px] mr-[12px]'>Advanced Mode</span>
		</div>

		{
			!isAdvancedMode && <YourRewardsTabRegularMode keys={keys}
				onClaimAllClick={onClaimAllClick}
				claimableTotal={claimableTotalAmount}
				keysQty={keys.length}
				paused={paused}
			/>
		}

		{
			isAdvancedMode && <YourRewardsTabAdvancedMode keys={keys}
				onClaimClick={( keysToBeClaimed ) => onClickClaim( keysToBeClaimed )}
				paused={paused}
			/>
		}
	</div>;
}
